import { useEffect } from "react";
import { Header, Footer } from "../components/Shell";

const LEGAL_ADDRESS = `Jl. Soekarno Hatta No. 381, Bugangin, Kec. Kendal, Kab. Kendal, Jawa Tengah 51314`;
const LEGAL_WA = `0851-5700-9099 — Rara (Admin)`;

function LegalShell({ title, kicker, children, testId }) {
  useEffect(() => { document.title = `${title} — MasTofa.com`; }, [title]);
  return (
    <div>
      <Header />
      <main className="page legal-page" data-testid={testId || `legal-${kicker.toLowerCase().replace(/\s+/g, "-")}`}>
        <div className="page-intro">
          <span className="section-kicker">{kicker}</span>
          <h1>{title}</h1>
          <p>Efektif sejak: Februari 2026. Terakhir diperbarui: Februari 2026.</p>
        </div>
        <article className="legal-body">{children}</article>
        <div className="legal-contact">
          <b>Kontak</b>
          <p>MASTOFA.COM</p>
          <p>{LEGAL_ADDRESS}</p>
          <p>WhatsApp: {LEGAL_WA}</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export function Terms() {
  return (
    <LegalShell title="Syarat & Ketentuan" kicker="SYARAT & KETENTUAN">
      <h3>1. Definisi</h3>
      <p>&ldquo;Kami&rdquo; berarti MASTOFA.COM. &ldquo;Anda&rdquo; berarti pengunjung atau member yang menggunakan layanan.</p>

      <h3>2. Layanan</h3>
      <p>MASTOFA.COM menyediakan Jasa Iklan, Jasa Pembuatan Landing Page, Privat 1-on-1, VIP Member, dan E-course di bidang digital marketing.</p>

      <h3>3. Akun & Membership</h3>
      <p>Anda bertanggung jawab menjaga kerahasiaan akun. Kami dapat menangguhkan akun bila terjadi pelanggaran ketentuan.</p>

      <h3>4. Pembayaran</h3>
      <p>Semua pembayaran diproses melalui gateway resmi Duitku. Layanan aktif setelah pembayaran terverifikasi dan invoice diterbitkan.</p>

      <h3>5. Jasa Iklan — Ketentuan Khusus</h3>
      <p>Paket 1 bulan Rp 5.000.000 atau paket 3 bulan Rp 10.500.000 (setara Rp 3.500.000/bulan). <b>Komitmen layanan minimal 1 tahun</b>. Digital marketing tidak menjamin omzet, profit, ROAS, atau order tertentu.</p>

      <h3>6. Kekayaan Intelektual</h3>
      <p>Seluruh materi kursus, template, ebook, dan konten premium adalah milik MASTOFA.COM. Dilarang menyalin, membagikan akses, atau menjual ulang tanpa izin tertulis.</p>

      <h3>7. Larangan</h3>
      <p>Anda dilarang menggunakan platform untuk aktivitas ilegal, spam, mengganggu operasi sistem, atau menyalahgunakan akses.</p>

      <h3>8. Pembatasan Tanggung Jawab</h3>
      <p>Sepanjang diizinkan hukum, tanggung jawab kami terbatas pada nilai transaksi yang bersangkutan. Kami tidak bertanggung jawab atas kerugian tidak langsung.</p>

      <h3>9. Pemutusan</h3>
      <p>Kami dapat memutus akses bila terjadi pelanggaran material. Ketentuan refund atau cancellation mengikuti kebijakan yang berlaku.</p>

      <h3>10. Perselisihan</h3>
      <p>Setiap perselisihan diselesaikan secara musyawarah. Bila tidak tercapai, tunduk pada hukum Republik Indonesia dan yurisdiksi Pengadilan Negeri Kendal.</p>

      <h3>11. Perubahan</h3>
      <p>Kami dapat memperbarui syarat ini sewaktu-waktu. Perubahan berlaku sejak dipublikasikan.</p>
    </LegalShell>
  );
}

export function Refund() {
  return (
    <LegalShell title="Kebijakan Refund" kicker="REFUND POLICY">
      <h3>1. Prinsip Umum</h3>
      <p>Kami berkomitmen memberikan layanan terbaik. Kebijakan refund dibuat transparan untuk melindungi Anda dan menjaga keberlangsungan layanan.</p>

      <h3>2. Layanan Digital & Kursus</h3>
      <p>Setelah akses kursus / produk digital / lesson diaktifkan, pembelian tidak dapat direfund karena sifatnya sekali klaim. Pastikan Anda membaca deskripsi produk sebelum membeli.</p>

      <h3>3. Jasa Iklan</h3>
      <p>Setelah Zoom onboarding dilaksanakan dan setup campaign dimulai, pembayaran yang telah dibayarkan di muka tidak dapat direfund. Pembatalan sebelum onboarding akan ditinjau kasus-per-kasus dengan potongan biaya administrasi yang berlaku.</p>

      <h3>4. Privat 1-on-1</h3>
      <p>Sesi yang telah dijadwalkan dan/atau dilaksanakan tidak dapat direfund. Reschedule dapat diminta minimal 1×24 jam sebelum sesi.</p>

      <h3>5. VIP Member</h3>
      <p>VIP Member adalah subscription bulanan; pembatalan menghentikan perpanjangan berikutnya dan tidak mengembalikan pembayaran periode berjalan.</p>

      <h3>6. Kesalahan Pembayaran</h3>
      <p>Bila terjadi pembayaran ganda atau nominal tidak sesuai, hubungi Admin dalam 3×24 jam disertai bukti bayar. Kami akan memproses pengembalian dana ke rekening asal.</p>

      <h3>7. Cara Mengajukan</h3>
      <p>Kirim pengaduan resmi via halaman <a href="/complaint">Pengaduan</a>. Anda akan mendapatkan nomor tiket untuk pelacakan.</p>
    </LegalShell>
  );
}

export function Cancellation() {
  return (
    <LegalShell title="Kebijakan Pembatalan" kicker="CANCELLATION POLICY">
      <h3>1. Sebelum Pembayaran</h3>
      <p>Anda bebas membatalkan pesanan kapan saja sebelum melakukan pembayaran.</p>

      <h3>2. Setelah Pembayaran, Sebelum Onboarding (Jasa Iklan)</h3>
      <p>Pembatalan dapat ditinjau dengan potongan biaya administrasi. Pengajuan dilakukan tertulis via halaman <a href="/complaint">Pengaduan</a>.</p>

      <h3>3. Setelah Onboarding</h3>
      <p>Setelah Zoom onboarding dan/atau setup campaign dilakukan, pembatalan tidak menghapus kewajiban pembayaran periode berjalan. Sisa periode kontrak tetap berlaku.</p>

      <h3>4. Selama Kontrak</h3>
      <p>Jasa Iklan berkontrak minimal 1 tahun. Pemutusan lebih awal dapat dilakukan hanya melalui kesepakatan tertulis kedua pihak.</p>

      <h3>5. VIP / Subscription</h3>
      <p>Pembatalan menghentikan perpanjangan otomatis. Periode berjalan tetap aktif sampai berakhir.</p>

      <h3>6. Kondisi Khusus</h3>
      <p>Force majeure, gangguan sistem berkepanjangan, atau kondisi luar biasa lainnya akan ditinjau kasus-per-kasus.</p>
    </LegalShell>
  );
}

export function Cookie() {
  return (
    <LegalShell title="Kebijakan Cookie" kicker="COOKIE POLICY">
      <h3>1. Apa itu Cookies</h3>
      <p>Cookie adalah file kecil yang disimpan browser untuk mengingat preferensi dan aktivitas Anda di website.</p>

      <h3>2. Jenis Cookies yang Kami Gunakan</h3>
      <p><b>Necessary</b> — session login, keranjang, preferensi. Wajib untuk operasional website.</p>
      <p><b>Analytics</b> — Meta Pixel, TikTok Pixel, Google Analytics 4 — untuk mengukur performa iklan & konten.</p>
      <p><b>Marketing</b> — untuk personalisasi iklan yang relevan.</p>
      <p><b>Preferences</b> — bahasa, theme, dan pengaturan tampilan.</p>

      <h3>3. Data yang Dihash</h3>
      <p>Data personal (email/phone) yang dikirim ke pixel tracking di-hash SHA-256 sebelum dikirim, sesuai standar Advanced Matching Meta & TikTok.</p>

      <h3>4. Kontrol Anda</h3>
      <p>Anda dapat menonaktifkan cookies melalui pengaturan browser. Menonaktifkan cookies necessary dapat mengganggu fungsi login dan checkout.</p>

      <h3>5. Perubahan</h3>
      <p>Kebijakan ini dapat diperbarui. Perubahan berlaku sejak dipublikasikan.</p>
    </LegalShell>
  );
}

export function Disclaimer() {
  return (
    <LegalShell title="Disclaimer" kicker="DISCLAIMER">
      <h3>1. Informasi Digital Marketing</h3>
      <p>Seluruh materi, konten, contoh case, dan angka yang disampaikan di MASTOFA.COM bersifat edukatif dan tidak menjamin hasil bisnis tertentu.</p>

      <h3>2. Tidak Ada Jaminan Hasil</h3>
      <p>Digital marketing bergantung pada banyak variabel: produk, harga, margin, pasar, kompetisi, timing, dan eksekusi. Kami tidak menjanjikan omzet, profit, ROAS, atau order pasti.</p>

      <h3>3. Keputusan Bisnis</h3>
      <p>Keputusan menjalankan bisnis, menaikkan budget iklan, atau menerapkan strategi tertentu sepenuhnya berada pada Anda / klien.</p>

      <h3>4. Data Pihak Ketiga</h3>
      <p>Data performa iklan berasal dari platform (Meta, TikTok, Shopee, dsb) yang dapat berubah kebijakan sewaktu-waktu di luar kendali kami.</p>

      <h3>5. Konten Blog / Testimonial</h3>
      <p>Testimoni yang ditampilkan (bila ada) berasal dari pengguna aktual. Hasil setiap orang berbeda-beda dan bukan jaminan untuk pengguna lain.</p>
    </LegalShell>
  );
}

export function AiNotice() {
  return (
    <LegalShell title="AI Usage Notice" kicker="AI NOTICE">
      <h3>1. Penggunaan AI di MasTofa.com</h3>
      <p>Website ini menggunakan AI Consultant untuk membantu menjawab pertanyaan, memberikan edukasi, membantu belajar, dan merekomendasikan layanan.</p>

      <h3>2. AI Bukan Manusia</h3>
      <p>AI adalah program yang dapat melakukan kesalahan. Jangan menganggap jawaban AI sebagai nasihat hukum, medis, keuangan, atau profesional yang mengikat.</p>

      <h3>3. Verifikasi Informasi Penting</h3>
      <p>Untuk informasi harga, kontrak, jadwal, atau kondisi khusus — konfirmasi langsung ke Admin Rara di WhatsApp 0851-5700-9099.</p>

      <h3>4. Data yang Diproses</h3>
      <p>Percakapan Anda dengan AI diproses melalui provider LLM (OpenAI) dan disimpan untuk keperluan quality control & analytics. Jangan mengirim data sensitif (password, OTP, PIN, data pribadi orang lain).</p>

      <h3>5. Batasan</h3>
      <p>AI tidak menjanjikan hasil bisnis (omzet, profit, ROAS). AI tidak boleh diminta melakukan tindakan berbahaya, ilegal, atau melanggar hak orang lain.</p>
    </LegalShell>
  );
}

export function IpPolicy() {
  return (
    <LegalShell title="Kebijakan Hak Kekayaan Intelektual" kicker="INTELLECTUAL PROPERTY">
      <h3>1. Kepemilikan</h3>
      <p>Logo, brand &ldquo;MASTOFA.COM&rdquo;, artikel, video, kursus, ebook, modul, template, software, dan seluruh konten premium adalah milik MASTOFA.COM.</p>

      <h3>2. Larangan</h3>
      <p>Anda dilarang:</p>
      <ul>
        <li>Membajak atau memperbanyak konten tanpa izin.</li>
        <li>Menjual ulang materi kursus, ebook, atau template.</li>
        <li>Membagikan akun / akses ke pihak lain.</li>
        <li>Mendistribusikan ulang materi ke platform lain.</li>
        <li>Mengklaim konten sebagai milik sendiri.</li>
      </ul>

      <h3>3. Konsekuensi</h3>
      <p>Pelanggaran dapat berujung pada penonaktifan akun, tuntutan hukum sesuai UU Hak Cipta, dan tuntutan ganti rugi.</p>

      <h3>4. User Generated Content</h3>
      <p>Bila Anda mengirim testimonial, review, atau konten lain ke platform kami, Anda memberi izin kepada MASTOFA.COM untuk menggunakannya secara wajar dalam materi promosi, kecuali dinyatakan lain secara tertulis.</p>

      <h3>5. Klaim</h3>
      <p>Bila Anda merasa hak cipta Anda dilanggar oleh konten di MASTOFA.COM, kirim klaim resmi ke <a href="/complaint">halaman Pengaduan</a> dengan bukti kepemilikan yang jelas.</p>
    </LegalShell>
  );
}
